import "./bootstrap";
import "../css/app.css";

import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import PopUpMessageProvider from "./Components/contexts/PopUpMessageProvider";

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.tsx`,
      import.meta.glob("./Pages/**/*.tsx"),
    ),
  setup({ el, App, props }) {
    const root = createRoot(el);

    root.render(
      <PopUpMessageProvider>
        <div className="overflow-hidden">
          <App {...props} />
        </div>
      </PopUpMessageProvider>,
    );
  },
  progress: {
    color: "#4B5563",
  },
});
